import React from 'react';
import { Link } from 'react-router-dom';
import CustomButton from '../../../../commons/custom-button/custom-button.component';

import './password-help.styles.scss';
import PrimaryCustomButton from '../../../../commons/primary-custom-button/primary-custom-button.component';

function PasswordHelp() {
  return (
    <div className="password-help module-spacer">
      <div className="form-container background action-item">
        <h2>Password Help</h2>
        <p className="blurb">
          Instructions for resetting your password have been sent to your email
          address.
        </p>

        <Link to="/user-login">
      
        <PrimaryCustomButton title={'Return to Sign in'}/>
        </Link>
      </div>
    </div>
  );
}

export default PasswordHelp;
